import request from '@api/request';
import { BuildHeaders } from '@utilities/build-headers';

export type ApiQuery = Record<string, unknown>;

export const catalogGet = <T = unknown>(url: string, query?: ApiQuery) => {
  const headers = BuildHeaders(query ?? {});

  return request.get<T>(url, undefined, { headers });
};
